// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file v1/user_manager.proto (package v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Date } from "../google/type/date_pb";
import { file_google_type_date } from "../google/type/date_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file v1/user_manager.proto.
 */
export const file_v1_user_manager: GenFile = /*@__PURE__*/
  fileDesc("ChV2MS91c2VyX21hbmFnZXIucHJvdG8SAnYxIlcKD1VzZXJMaXN0UmVxdWVzdBIMCgRwYWdlGAEgASgFEg0KBWxpbWl0GAIgASgFEg4KBnNlYXJjaBgDIAEoCRIXCg9pbmNsdWRlX2V4cGlyZWQYBCABKAgiVwoQVXNlckxpc3RSZXNwb25zZRIXCgV1c2VycxgBIAMoCzIILnYxLlVzZXISDQoFdG90YWwYAiABKAUSDAoEcGFnZRgDIAEoBRINCgVsaW1pdBgEIAEoBSKjAQoEVXNlchIKCgJpZBgBIAEoCRIQCgh1c2VybmFtZRgCIAEoCRINCgVlbWFpbBgDIAEoCRIMCgRyb2xlGAQgASgJEicKDGV4cGlyZWRfZGF0ZRgHIAEoCzIRLmdvb2dsZS50eXBlLkRhdGUSGAoQY2FsY3VsYXRpb25fdHlwZRgIIAEoCRIRCglncm91cG5hbWUYCSABKAlKBAgFEAZKBAgGEAciQAoSRXh0ZW5kVXNlcnNSZXF1ZXN0EhAKCHVzZXJfaWRzGAEgAygJEhgKEGV4dGVuc2lvbl9wZXJpb2QYAiABKAkiTwoTRXh0ZW5kVXNlcnNSZXNwb25zZRIPCgdzdWNjZXNzGAEgASgIEg8KB21lc3NhZ2UYAiABKAkSFgoOYWZmZWN0ZWRfY291bnQYAyABKAUicgoRVXNlckNyZWF0ZVJlcXVlc3QSEAoIdXNlcm5hbWUYASABKAkSEAoIcGFzc3dvcmQYAiABKAkSDAoEcm9sZRgDIAEoCRIYChBjYWxjdWxhdGlvbl90eXBlGAQgASgJEhEKCWdyb3VwbmFtZRgFIAEoCSJOChJVc2VyQ3JlYXRlUmVzcG9uc2USDwoHc3VjY2VzcxgBIAEoCBIPCgdtZXNzYWdlGAIgASgJEhYKBHVzZXIYAyABKAsyCC52MS5Vc2VyIicKFFJlc2V0UGFzc3dvcmRSZXF1ZXN0Eg8KB3VzZXJfaWQYASABKAkiUQoVUmVzZXRQYXNzd29yZFJlc3BvbnNlEg8KB3N1Y2Nlc3MYASABKAgSDwoHbWVzc2FnZRgCIAEoCRIWCg5hZmZlY3RlZF9jb3VudBgDIAEoBTKWAgoSVXNlck1hbmFnZXJTZXJ2aWNlEjcKCFVzZXJMaXN0EhMudjEuVXNlckxpc3RSZXF1ZXN0GhQudjEuVXNlckxpc3RSZXNwb25zZSIAEkAKC0V4dGVuZFVzZXJzEhYudjEuRXh0ZW5kVXNlcnNSZXF1ZXN0GhcudjEuRXh0ZW5kVXNlcnNSZXNwb25zZSIAEj0KClVzZXJDcmVhdGUSFS52MS5Vc2VyQ3JlYXRlUmVxdWVzdBoWLnYxLlVzZXJDcmVhdGVSZXNwb25zZSIAEkYKDVJlc2V0UGFzc3dvcmQSGC52MS5SZXNldFBhc3N3b3JkUmVxdWVzdBoZLnYxLlJlc2V0UGFzc3dvcmRSZXNwb25zZSIAQihaJmdpdGh1Yi5jb20vZHVjYnQvdHQtZ28vZ2VuL3Byb3RvL3YxO3YxYgZwcm90bzM", [file_google_type_date]);

/**
 * @generated from message v1.UserListRequest
 */
export type UserListRequest = Message<"v1.UserListRequest"> & {
  /**
   * @generated from field: int32 page = 1;
   */
  page: number;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit: number;

  /**
   * @generated from field: string search = 3;
   */
  search: string;

  /**
   * If false, only return users with expired_date > current time
   *
   * @generated from field: bool include_expired = 4;
   */
  includeExpired: boolean;
};

/**
 * Describes the message v1.UserListRequest.
 * Use `create(UserListRequestSchema)` to create a new message.
 */
export const UserListRequestSchema: GenMessage<UserListRequest> = /*@__PURE__*/
  messageDesc(file_v1_user_manager, 0);

/**
 * @generated from message v1.UserListResponse
 */
export type UserListResponse = Message<"v1.UserListResponse"> & {
  /**
   * @generated from field: repeated v1.User users = 1;
   */
  users: User[];

  /**
   * @generated from field: int32 total = 2;
   */
  total: number;

  /**
   * @generated from field: int32 page = 3;
   */
  page: number;

  /**
   * @generated from field: int32 limit = 4;
   */
  limit: number;
};

/**
 * Describes the message v1.UserListResponse.
 * Use `create(UserListResponseSchema)` to create a new message.
 */
export const UserListResponseSchema: GenMessage<UserListResponse> = /*@__PURE__*/
  messageDesc(file_v1_user_manager, 1);

/**
 * @generated from message v1.User
 */
export type User = Message<"v1.User"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string username = 2;
   */
  username: string;

  /**
   * @generated from field: string email = 3;
   */
  email: string;

  /**
   * @generated from field: string role = 4;
   */
  role: string;

  /**
   * @generated from field: google.type.Date expired_date = 7;
   */
  expiredDate?: Date;

  /**
   * @generated from field: string calculation_type = 8;
   */
  calculationType: string;

  /**
   * @generated from field: string groupname = 9;
   */
  groupname: string;
};

/**
 * Describes the message v1.User.
 * Use `create(UserSchema)` to create a new message.
 */
export const UserSchema: GenMessage<User> = /*@__PURE__*/
  messageDesc(file_v1_user_manager, 2);

/**
 * @generated from message v1.ExtendUsersRequest
 */
export type ExtendUsersRequest = Message<"v1.ExtendUsersRequest"> & {
  /**
   * @generated from field: repeated string user_ids = 1;
   */
  userIds: string[];

  /**
   * @generated from field: string extension_period = 2;
   */
  extensionPeriod: string;
};

/**
 * Describes the message v1.ExtendUsersRequest.
 * Use `create(ExtendUsersRequestSchema)` to create a new message.
 */
export const ExtendUsersRequestSchema: GenMessage<ExtendUsersRequest> = /*@__PURE__*/
  messageDesc(file_v1_user_manager, 3);

/**
 * @generated from message v1.ExtendUsersResponse
 */
export type ExtendUsersResponse = Message<"v1.ExtendUsersResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * @generated from field: int32 affected_count = 3;
   */
  affectedCount: number;
};

/**
 * Describes the message v1.ExtendUsersResponse.
 * Use `create(ExtendUsersResponseSchema)` to create a new message.
 */
export const ExtendUsersResponseSchema: GenMessage<ExtendUsersResponse> = /*@__PURE__*/
  messageDesc(file_v1_user_manager, 4);

/**
 * @generated from message v1.UserCreateRequest
 */
export type UserCreateRequest = Message<"v1.UserCreateRequest"> & {
  /**
   * @generated from field: string username = 1;
   */
  username: string;

  /**
   * @generated from field: string password = 2;
   */
  password: string;

  /**
   * @generated from field: string role = 3;
   */
  role: string;

  /**
   * @generated from field: string calculation_type = 4;
   */
  calculationType: string;

  /**
   * @generated from field: string groupname = 5;
   */
  groupname: string;
};

/**
 * Describes the message v1.UserCreateRequest.
 * Use `create(UserCreateRequestSchema)` to create a new message.
 */
export const UserCreateRequestSchema: GenMessage<UserCreateRequest> = /*@__PURE__*/
  messageDesc(file_v1_user_manager, 5);

/**
 * @generated from message v1.UserCreateResponse
 */
export type UserCreateResponse = Message<"v1.UserCreateResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * @generated from field: v1.User user = 3;
   */
  user?: User;
};

/**
 * Describes the message v1.UserCreateResponse.
 * Use `create(UserCreateResponseSchema)` to create a new message.
 */
export const UserCreateResponseSchema: GenMessage<UserCreateResponse> = /*@__PURE__*/
  messageDesc(file_v1_user_manager, 6);

/**
 * @generated from message v1.ResetPasswordRequest
 */
export type ResetPasswordRequest = Message<"v1.ResetPasswordRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;
};

/**
 * Describes the message v1.ResetPasswordRequest.
 * Use `create(ResetPasswordRequestSchema)` to create a new message.
 */
export const ResetPasswordRequestSchema: GenMessage<ResetPasswordRequest> = /*@__PURE__*/
  messageDesc(file_v1_user_manager, 7);

/**
 * @generated from message v1.ResetPasswordResponse
 */
export type ResetPasswordResponse = Message<"v1.ResetPasswordResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * @generated from field: int32 affected_count = 3;
   */
  affectedCount: number;
};

/**
 * Describes the message v1.ResetPasswordResponse.
 * Use `create(ResetPasswordResponseSchema)` to create a new message.
 */
export const ResetPasswordResponseSchema: GenMessage<ResetPasswordResponse> = /*@__PURE__*/
  messageDesc(file_v1_user_manager, 8);

/**
 * @generated from service v1.UserManagerService
 */
export const UserManagerService: GenService<{
  /**
   * @generated from rpc v1.UserManagerService.UserList
   */
  userList: {
    methodKind: "unary";
    input: typeof UserListRequestSchema;
    output: typeof UserListResponseSchema;
  },
  /**
   * @generated from rpc v1.UserManagerService.ExtendUsers
   */
  extendUsers: {
    methodKind: "unary";
    input: typeof ExtendUsersRequestSchema;
    output: typeof ExtendUsersResponseSchema;
  },
  /**
   * @generated from rpc v1.UserManagerService.UserCreate
   */
  userCreate: {
    methodKind: "unary";
    input: typeof UserCreateRequestSchema;
    output: typeof UserCreateResponseSchema;
  },
  /**
   * @generated from rpc v1.UserManagerService.ResetPassword
   */
  resetPassword: {
    methodKind: "unary";
    input: typeof ResetPasswordRequestSchema;
    output: typeof ResetPasswordResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_v1_user_manager, 0);

